import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import req from "../../axios/interceptedAxiosInstance";

const getCategory = async () => {
  const response = await req.get("product/category");
  return response.data.data;
};

const getBrand = async () => {
  const response = await req.get("product/brand");
  return response.data.data;
};

const getSize = async () => {
  const response = await req.get("product/product-size");
  return response.data.data;
};

const getGender = async () => {
  const response = await req.get("product/gender");
  return response.data.data;
};

const getProducts = async () => {
  const response = await req.get("product");
  return response.data.data;
};

export const getExploreData = createAsyncThunk("explore/getData", async () => {
  const response = Promise.all([
    getCategory(),
    getBrand(),
    getSize(),
    getGender(),
    getProducts(),
  ]).catch((error) => console.log(error));
  return response;
});

const initialState = {
  categories: [],
  brands: [],
  sizes: [],
  gender: [],
  products: [],
  loading: true,
};

const exploreSlice = createSlice({
  name: "explore",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getExploreData.fulfilled, (state, action) => {
      state.categories = action.payload[0];
      state.brands = action.payload[1];
      state.sizes = action.payload[2];
      state.gender = action.payload[3];
      state.products = action.payload[4];
      state.loading = false;
    });
  },
});

export default exploreSlice.reducer;
